// Chinese translations for the 6 experience roles (index-aligned with EXPERIENCE in portfolio.js)
export const EXPERIENCE_ZH = [
  {
    role: "Java 软件开发工程师",
    type: "合同制",
    bullets: [
      "使用 Java Spring（JSF 与 Hibernate JPA）和 PostgreSQL，将企业 BSS 平台与 LG U+ Nerget 和 StarHub 电信系统集成。",
      "管理 AWS 云基础设施，包括 EC2、RDS、VPC、Route 53 以及 EKS Kubernetes 集群（GitHub Actions 与 ArgoCD），支持生产应用运行。",
      "配置并维护 Cisco ISR 路由器、Catalyst 交换机和 ASA 防火墙。",
      "与跨职能团队协作，按时交付企业系统集成项目。",
    ],
  },
  {
    role: "软件架构师",
    type: "定期自由职业",
    bullets: [
      "为提供认证、社区、评论和市场服务的 HiddenTag Global 平台设计后端架构。",
      "使用 Spring Boot、Hibernate JPA、MyBatis 和 MySQL 开发 RESTful API 和数据库架构。",
      "将应用部署从传统 Tomcat 服务器迁移至 AWS 上的 Docker 容器化基础设施。",
      "成功支持 HiddenTag Global 平台的生产上线。",
    ],
  },
  {
    role: "应用架构师",
    type: "合同制",
    bullets: [
      "在 AWS 上完成 SEHATI 巴林国家健康保险系统现代化：JDK 7 → 8、Tomcat 7 → 9、Oracle RDS 12c → 19c。",
      "为新一代 GS Postbox 系统在 GitOps / ArgoCD Kubernetes 环境中构建 CI/CD 流水线和自动化部署。",
      "通过自定义 Maven 配置文件，为基于 Adobe AEM 框架的 LG U+ 数字目录系统实现 Jenkins 自动化部署。",
      "管理并部署新韩银行 The Next Project 的接口服务（MCI / FEP / EAI 服务网格）。",
      "为新一代韩国社会保障信息系统开发基于 MyBatis 的 Java Batch 服务。",
    ],
  },
  {
    role: "软件开发工程师",
    type: "合同制",
    bullets: [
      "为 Middleblock 区块链平台（Hyperledger Indy、Aries 与 Fabric）开发 Java Spring 集成 REST API 网关服务器。",
      "使用 Hadoop、Spark、Hive、Django 和 React，设计并实现丽水数据旗舰项目的大数据仓库基础设施和监控平台。",
    ],
  },
  {
    role: "软件开发工程师",
    type: "合同制",
    bullets: [
      "将主传感器网关后端从 Go 迁移至 Java Spring（TCP/IP socket、gRPC、REST API），并实现基于 Kafka 的数据管道。",
      "使用 Apache Nifi 和 Streamsets 升级 Kafka 管道；构建高城与泗川旅游传感器 IoT 仪表盘（React、Java Spring、MariaDB）。",
      "管理支持多个客户应用的 Docker 化 AWS 生产环境。",
    ],
  },
  {
    role: "AI 软件开发工程师",
    type: "合同制",
    bullets: [
      "使用 Java Spring、Angular 和 Python 为 KISA 政府项目开发 MICUBE AI 可视化工具仪表盘。",
      "基于振动传感器数据，使用 TensorFlow RMSE 模型为大德电子构建设备预测性维护应用。",
      "使用 TensorFlow Mask R-CNN 为现代忠州生物中心开发计算机视觉岩石检测应用。",
      "管理 Hadoop、Kafka、Ambari 和 Linux 服务器基础设施。",
    ],
  },
];
